import common from './common';
import selectors from './selectors';
import templates from './templates';

export default {
  common,
  selectors,
  templates,
};
